import {WidgetEventStruct} from '../../widget-event.struct';
import {DeviceWidgetEnum, EmailWidgetEnum} from '../../../enums';

export class EmailWidgetEventStruct extends WidgetEventStruct {
  public event_email_widget_type: EmailWidgetEnum;
} // end Package
